module.exports = __webpack_public_path__ + "img/gear-disabled.62027e53.svg";